import { Button } from '@bluebeam/react-skyline-button';
import {
  RichTranslator,
  useDateFormatter,
  useTranslator,
} from '@bluebeam/react-i18n';
import { BannerContext } from 'components/Routes/BannerContext';
import AppStoreContext from 'contexts/AppStoreContext';
import { DateTime } from 'luxon';
import * as React from 'react';
import { useContext } from 'react';
import './TrialBanner.css';

const TrialBanner: React.VFC = () => {
  const { translate } = useTranslator([
    'trialBanner',
    'freshStartSubscriptionBanner',
  ]);
  const { state: appState } = useContext(AppStoreContext);
  const { setHeight } = useContext(BannerContext);
  const { isTrial } = appState.userLicense;
  if (!isTrial) {
    return null;
  }

  const { trialDaysRemaining } = appState.userLicense;

  const isTrialExpired = trialDaysRemaining <= 0;
  const dateFormatter = useDateFormatter({
    dateStyle: 'long',
  });

  const expiredContent = () => {
    return (
      <span>
        <RichTranslator
          components={[
            // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/control-has-associated-label
            <strong />,
          ]}
          translationKey="trialBanner:expiredContent"
        />
      </span>
    );
  };

  const upgradeButtonClicked = () => {
    window.open(process.env.BB_SUBSCRIPTION_PATH, '_blank');
  };

  const expiringContent = () => {
    const expirationDate = DateTime.local()
      .plus({
        days: trialDaysRemaining,
      })
      .toJSDate();
    const expirationDateFormatted = dateFormatter?.format(expirationDate);
    return (
      <span>
        <RichTranslator
          components={[
            // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/control-has-associated-label
            <strong />,
          ]}
          variables={{
            trialDaysRemaining,
            expirationDate: expirationDateFormatted,
          }}
          translationKey="trialBanner:expiringContent"
        />
      </span>
    );
  };

  return (
    <div className="trial-banner row justify-center items-center w100 bb-2 bgd-light-grey-2 size-16">
      {isTrialExpired ? expiredContent() : expiringContent()}
      <Button
        className="ml4"
        size="32px"
        variant="outline"
        onClick={upgradeButtonClicked}
      >
        {translate('freshStartSubscriptionBanner:buyNow')}
      </Button>
    </div>
  );
};

export default TrialBanner;
